import React from "react";
import { Nav } from "react-bootstrap";
import { FaShoppingCart, FaUsers, FaChartBar, FaHome, FaImage, FaCog, FaClipboardList } from "react-icons/fa";
import { MdAdsClick } from "react-icons/md";
import { RiDiscountPercentFill } from "react-icons/ri";
import { IoMdPricetag } from "react-icons/io";
import { useContext } from "react";
import { GlobalContext } from "../../../../store/GlobalContext";
import { useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { useI18n } from "../../../../i18n/I18nContext";

const Sidebar = ({ componentName, setComponentName }) => {
  const { state, logout } = useContext(GlobalContext);
  const { t } = useI18n();
  const navigate = useNavigate();
  const userRoles: string[] = Array.isArray(state?.auth?.user?.roles) ? state.auth.user.roles : [];

  const menuConfig = [
    { name: t('admin_sidebar_home'), path: "Home", icon: <FaHome /> },
    { name: t('admin_sidebar_orders'), path: "Orders", icon: <FaShoppingCart /> },
    { name: t('admin_sidebar_carts'), path: "Carts", icon: <FaShoppingCart /> },
    { name: t('admin_sidebar_products'), path: "Products", icon: <IoMdPricetag /> },
    { name: t('admin_sidebar_delivery_boys'), path: "DeliveryBoys", icon: <FaUsers /> },
    { name: t('admin_sidebar_promotions'), path: "Promotions", icon: <RiDiscountPercentFill /> },
    { name: t('admin_sidebar_announcements'), path: "Announcements", icon: <MdAdsClick /> },
    { name: t('admin_sidebar_returns'), path: "Returns", icon: <FaClipboardList /> },
    { name: t('admin_sidebar_logs'), path: "Logs", icon: <FaClipboardList /> },
    { name: t('admin_sidebar_reviews'), path: "Reviews", icon: <FaChartBar /> },
    { name: t('admin_sidebar_categories'), path: "Categories", icon: <IoMdPricetag /> },
    { name: 'Contact Messages', path: "ContactMessages", icon: <FaClipboardList /> },
    { name: t('admin_sidebar_customers'), path: "Customers", icon: <FaUsers /> },
    { name: t('admin_sidebar_admin_users'), path: "AdminUsers", icon: <FaUsers />, roles: ["super_admin"] },
    { name: t('admin_sidebar_registered_users'), path: "RegisteredUsers", icon: <FaUsers />, roles: ["super_admin"] },
    { name: "Content", path: "Content", icon: <FaImage />, enabled: false },
    { name: "Analytics", path: "Analytics", icon: <FaChartBar />, enabled: false },
    { name: "Marketing", path: "Marketing", icon: <MdAdsClick />, enabled: false },
  ];

  const menuItems = menuConfig.filter((item) => {
    if (item.enabled === false) return false;
    if (!item.roles) return true;
    return item.roles.some((role) => userRoles.includes(role));
  });

  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar-brand">Arkab Admin</div>

      <Nav className="flex-column admin-sidebar-nav">
        {menuItems.map((item, index) => (
          <Nav.Link
            className={`admin-sidebar-link ${componentName === item.path ? 'is-active' : ''}`}
            key={index}
            onClick={() => setComponentName(item.path)}
          >
            <span className="admin-sidebar-link-icon">{item?.icon}</span>
            <span>{item?.name}</span>
          </Nav.Link>
        ))}
      </Nav>

      <Nav className="flex-column admin-sidebar-footer">
        <Nav.Link
          className={`admin-sidebar-link ${componentName === 'Settings' ? 'is-active' : ''}`}
          onClick={() => setComponentName("Settings")}
        >
          <span className="admin-sidebar-link-icon"><FaCog /></span>
          <span>{t('admin_sidebar_settings')}</span>
        </Nav.Link>

        <Nav.Link
          className="admin-sidebar-link"
          onClick={() => {
            logout();
            navigate('/admin/login');
          }}
        >
          <span className="admin-sidebar-link-icon"><FiLogOut /></span>
          <span>{t('common_logout')}</span>
        </Nav.Link>
      </Nav>
    </aside>
  );
};

export default Sidebar;
